import React, {useEffect} from 'react';
import bootcampcard1 from '../Image/bootcampcard1.jpg'
   

function Bootcamps_page() {
    useEffect(()=>{
        document.title= 'Bootcamps | InternsElite';
      },[]);
  return (
    <div>
    {/* -----------------------Mobile View------------------------ */}
    <div>
    <div className='Mobile_Bootcamp_background_image d-sm-block d-md-none mt-5'>
        <div className='container-fluid mobile_Bootcamp_background_color pt-4'>
            <div className='text-center mobile_Bootcamp_Main_text py-5'>
                <h1 className='display-2 text-white'>Bootcamp</h1>
                <h3 className='text-white fs-4 pt-2'>Ignite Your Skills Across Courses!</h3>
            </div>
        </div>
    </div>
    <div className='container pt-4 d-sm-block d-md-none'>
    <div className='text-center Terms_Discraption_text'>
        <h1 className='display-6 text-center'>About Bootcamps!</h1>
        <p className='pb-4 Bootcamp_mobile_pera_text'>Welcome to DevTown, your gateway to a thriving tech future! We're excited to announce our 7-day Free Hands-on Bootcamps in AI, Web Development, Cyber Security and other tech domains, designed to catapult you into rewarding tech careers through immersive, project-based learning.</p>
    </div>
    </div>
    </div>

    {/* -------------------Desktop View------------------------- */}
    <div className='d-none d-md-block'>
    <div className='Bootcamp_background_image mt-5'>
        <div className='container-fluid Bootcamp_background_color pt-5'>
            <div className='text-center pt-5 Bootcamp_Main_text mt-2'>
                <h1 className='display-2 text-white'>Bootcamp</h1>
                <h3 className='text-white display-6 pt-4 '>Ignite Your Skills Across Courses!</h3>
            </div>
        </div>
    </div>
    <div className='container pt-5'>
        <div className='row'>
            <div className='col-md-1'></div>
            <div className='col-md-10'>
            <div className='Container'>
                <div className='text-center Terms_Discraption_text'>
                    <h1 className='display-5 pb-2'>About Bootcamps!</h1>
                    <p>Welcome to DevTown, your gateway to a thriving tech future! We're excited to announce our 7-day Free Hands-on Bootcamps in AI, Web Development, Cyber Security and other tech domains, designed to catapult you into rewarding tech careers through immersive, project-based learning.</p>
                </div>
                </div>
            </div>
            <div className='col-md-1'></div>
        </div>
    </div>

    <div className='container my-5'>
        <div className='row'>
            <div className='col-md-6'>
                <h1 className='px-4'>Program Highlights</h1>
                <ul className='pt-4'>
                    <li className='py-3'><b>Diverse Exploration:</b> Dive into the tech world acquiring broad perspectives and specialized skills.</li>
                    <li><b>Real-world Projects:</b> Develop in-depth knowledge with practical applications and projects.</li>
                    <li className='py-3'><b>Expert Instruction:</b> Learn from mentors securing internships at Microsoft, Jio, and Goldman Sachs.</li>
                    <li><b>Certified Learning:</b> Earn prestigious certifications from DevTown, AWS Students Club, Google Developers Group, and many other prestigious student communities.</li>
                    <li className='py-3'><b>Diverse Exploration:</b> Dive into the tech world acquiring broad perspectives and specialized skills.</li>
                </ul>
            </div>
            <div className='col-md-6'></div>
        </div>
    </div>

    <div className='container'>
    <h1 className='text-center display-3'>Timeline</h1>
        <div className='row my-4'>
            <div className='col-md-1'></div>
            <div className='col-md-2'>
                <div className='border border-5 rounded-circle py-3 text-center'>
                    <p className='display-6 fw-bold pt-4'>Stage</p>
                    <p className='display-6 fw-bold'>1</p>
                </div>
                <div className='text-center'>
                    <h1 className='fs-3 pt-4 pb-2'>Registration</h1>
                    <p>Your go-to destination for top-tier training programs, dedicated to nurturing talent and empowering individuals to reach their fullest potential.</p>
                </div>
            </div>
            <div className='col-md-2'>
            <div className='text-center'>
                    <h1 className='fs-3 pt-4 pb-2'>Registration</h1>
                    <p>Your go-to destination for top-tier training programs, dedicated to nurturing talent and empowering individuals to reach their fullest potential.</p>
                </div>
            <div className='border border-5 rounded-circle py-3 text-center'>
                    <p className='display-6 fw-bold pt-4'>Stage</p>
                    <p className='display-6 fw-bold'>2</p>
                </div>
            </div>
            <div className='col-md-2'>
            <div className='border border-5 rounded-circle py-3 text-center'>
                    <p className='display-6 fw-bold pt-4'>Stage</p>
                    <p className='display-6 fw-bold'>3</p>
                </div>
                <div className='text-center'>
                    <h1 className='fs-3 pt-4 pb-2'>Registration</h1>
                    <p>Your go-to destination for top-tier training programs, dedicated to nurturing talent and empowering individuals to reach their fullest potential.</p>
                </div>
            </div>
            <div className='col-md-2'>
            <div className='text-center'>
                <h1 className='fs-3 pt-4 pb-2'>Registration</h1>
                <p>Your go-to destination for top-tier training programs, dedicated to nurturing talent and empowering individuals to reach their fullest potential.</p>
            </div>
            <div className='border border-5 rounded-circle py-3 text-center'>
                    <p className='display-6 fw-bold pt-4'>Stage</p>
                    <p className='display-6 fw-bold'>4</p>
                </div>
            </div>
            <div className='col-md-2'>
            <div className='border border-5 rounded-circle py-3 text-center'>
                    <p className='display-6 fw-bold pt-4'>Stage</p>
                    <p className='display-6 fw-bold'>5</p>
                </div>
                <div className='text-center'>
                    <h1 className='fs-3 pt-4 pb-2'>Registration</h1>
                    <p>Your go-to destination for top-tier training programs, dedicated to nurturing talent and empowering individuals to reach their fullest potential.</p>
                </div>
            </div>
            <div className='col-md-1'>
            </div>
        </div>
    </div>

    <div className='container my-5'>
        <div className='row'>
            <div className='col-md-4'>
                <div className='p-2 border rounded'>
                    <div className=''>
                        <img className='bootcardimg border rounded' src={bootcampcard1}></img>
                    </div>
                    <div className='px-3 pb-3'>
                        <h1 className='fs-4 pt-3'>Machine Learning With python</h1>
                        <h1 className='fs-6 pt-2'>120+ Student Waiting</h1>
                        <div className='text-center'><button type="button" class="fs-5 btn btn-warning px-5 mt-3">Join</button></div>
                    </div>
                </div>
            </div>
            <div className='col-md-4'></div>
            <div className='col-md-4'></div>
        </div>
    </div>
    </div>
    </div>
    
  )
}

export default Bootcamps_page
